// extracted by mini-css-extract-plugin
export default {"alert":"bulk_actions-module___alert___f4d3933d"};